import { Component, OnInit } from '@angular/core';
import { ConfigurazioneGeneraleService } from '../services/configurazione-generale.service';

@Component({
  selector: 'jhi-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss']
})
export class LandingComponent implements OnInit {

  constructor(private configurazioneGeneraleService: ConfigurazioneGeneraleService) { }

  ngOnInit(): void {
  }

  goToHome():void{
    window.location.href = this.configurazioneGeneraleService.configurazione.linkHome;
  }

}
